"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getNonEmploymentIncomeTotal(nonemploymentIncome) {
  return Object.keys(nonemploymentIncome).filter(function (k) {
    return !["otherGovAssistanceNames", "otherIncomeNames", "otherDeductionNames"].includes(k);
  }).reduce(function (accum, key) {
    return accum + Number(nonemploymentIncome[key] || 0);
  }, 0);
}

exports.default = getNonEmploymentIncomeTotal;